import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/arrow-bottom.png'


const _withScopeId = n => (_pushScopeId("data-v-6d067e71"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "program-participation-record" }
const _hoisted_2 = { class: "search-wrapper" }
const _hoisted_3 = { class: "filter-group" }
const _hoisted_4 = { class: "dropdown" }
const _hoisted_5 = {
  id: "program-participation-record-filter",
  class: "btn btn-secondary d-flex align-items-center",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_6 = { class: "filter-text" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "arrow",
  src: _imports_0
}, null, -1))
const _hoisted_8 = {
  class: "dropdown-menu",
  "aria-labelledby": "program-participation-record-filter"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "dropdown-item" }
const _hoisted_11 = { class: "dropdown" }
const _hoisted_12 = {
  id: "program-participation-record-filter-order-by",
  class: "btn btn-secondary d-flex align-items-center",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_13 = { class: "filter-text" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "arrow",
  src: _imports_0
}, null, -1))
const _hoisted_15 = {
  class: "dropdown-menu",
  "aria-labelledby": "program-participation-record-filter-order-by"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "dropdown-item" }
const _hoisted_18 = { class: "list" }
const _hoisted_19 = {
  key: 0,
  class: "pagination-box"
}

import { computed, ref, reactive } from 'vue';
  import { userParticipationRecordStore, authStore } from '@/stores';
  import RecordItem from './components/program-participation-record-item.vue';
  import { useI18n } from 'vue-i18n';
  import { USER_REQUEST_STATE_MAP, USER_REQUEST_ORDER_BY_MAP } from '@/constants';
  import _ from 'lodash';
  import { useRoute, useRouter } from 'vue-router';
  import qs from 'qs';
  import { useMobileScrollMore } from '@/hooks/use-mobile-scroll-more';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const { t, locale } = useI18n();
  const route = useRoute();
  const router = useRouter();
  const store = reactive(userParticipationRecordStore);
  const keyword = ref<string>(route.query.keyword as string || '');
  const stateIndex = ref(0);
  const statusList = _.map(USER_REQUEST_STATE_MAP, (label, value) => ({ label, value }));
  const jaStatusList = ['approved', 'pending', 'closed'].map(item => ({ label: USER_REQUEST_STATE_MAP[item], value: item }));
  const status: Array<{ label: string; value: undefined | string; }> = [{ label: t('All status'), value: undefined }].concat(
    (locale.value === 'ja' ? jaStatusList : statusList) as any
  );

  const orderBy = ref('');
  const orderByList = _.map(USER_REQUEST_ORDER_BY_MAP, (label, value) => ({ label, value }));
  const orderByText = computed(() => {
    const item = orderByList.find(item => item.value === orderBy.value);
    if (!item) {
      return t('user_request.order_by.title');
    }
    return item.label;
  });
  function handleChangeOrderBy(value: string) {
    orderBy.value = value;
    const query = {
      ...route.query,
      order_by: value,
    };
    router.push({ query });
  }

  const handleTriggerStatus = (index: number) => {
    if (index === stateIndex.value) {
      return;
    }
    stateIndex.value = index;
    const stateEq = status[stateIndex.value].value;
    const query = {
      ...route.query,
      page: 1,
      state_eq: stateEq,
    };
    if (!stateEq) {
      store.params.state_eq = undefined;
    }
    router.push({ query });
  };

  const handleSearch = () => {
    const query = {
      ...route.query,
      page: 1,
      keyword: keyword.value,
    };
    router.push({ query });
  };

  const handlePageChange = (page: any) => {
    router.push({ query: { ...route.query, page: page } });
  };

  authStore.tryFetchData();

  function fetchData() {
    if (route.query.state_eq) {
      stateIndex.value = status.findIndex(item => item.value === route.query.state_eq);
    }
    if (route.query.order_by) {
      orderBy.value = route.query.order_by as string;
    }
    const newQuery = _.pick(route.query, ['page', 'keyword', 'state_eq', 'order_by']) as { page?: string; keyword?: string; state_eq?: string; order_by?: string; };
    // 判断参数是否一样
    if (JSON.stringify(newQuery) === JSON.stringify(store.query)) {
      store.tryFetchData();
      return;
    }
    store.updateQuery({
      page: newQuery.page ? Number(newQuery.page) : 1,
      keyword: newQuery.keyword,
      state_eq: newQuery.state_eq,
      order_by: newQuery.order_by,
    });
    store.fetchData();
  }
  fetchData();

  useMobileScrollMore(async () => {
    await store.fetchMoreData();
    const newQuery = {
      ...route.query,
      page: store.meta.page,
    };
    history.replaceState(null, '', `${window.location.pathname}?${qs.stringify(newQuery)}`);
  });

return (_ctx: any,_cache: any) => {
  const _component_AppSearch = _resolveComponent("AppSearch")!
  const _component_AppEmptyView = _resolveComponent("AppEmptyView")!
  const _component_AppPagination = _resolveComponent("AppPagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_AppSearch, {
        modelValue: keyword.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((keyword).value = $event)),
        modelModifiers: { trim: true },
        placeholder: _unref(t)('Searh campaign participation record'),
        onSearch: handleSearch,
        onClear: handleSearch
      }, null, 8, ["modelValue", "placeholder"]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(status)[stateIndex.value].label), 1),
            _hoisted_7
          ]),
          _createElementVNode("ul", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(status), (item, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: index,
                onClick: ($event: any) => (handleTriggerStatus(index))
              }, [
                _createElementVNode("span", _hoisted_10, _toDisplayString(item.label), 1)
              ], 8, _hoisted_9))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("button", _hoisted_12, [
            _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(orderByText)), 1),
            _hoisted_14
          ]),
          _createElementVNode("ul", _hoisted_15, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(orderByList), (item, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: index,
                onClick: ($event: any) => (handleChangeOrderBy(item.value))
              }, [
                _createElementVNode("span", _hoisted_17, _toDisplayString(item.label), 1)
              ], 8, _hoisted_16))
            }), 128))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).data, (item, index) => {
        return (_openBlock(), _createBlock(RecordItem, {
          key: index,
          modelValue: _unref(store).data[index],
          "onUpdate:modelValue": ($event: any) => ((_unref(store).data[index]) = $event),
          role: _unref(authStore).user.company_account?.role
        }, null, 8, ["modelValue", "onUpdate:modelValue", "role"]))
      }), 128)),
      (_unref(store).isEmpty)
        ? (_openBlock(), _createBlock(_component_AppEmptyView, {
            key: 0,
            text: _unref(t)('No Program participation record')
          }, null, 8, ["text"]))
        : _createCommentVNode("", true)
    ]),
    (_unref(store).meta.total)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createVNode(_component_AppPagination, {
            total: _unref(store).meta.total,
            "per-page": _unref(store).meta.per_page,
            page: _unref(store).meta.page,
            onChange: handlePageChange
          }, null, 8, ["total", "per-page", "page"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})